import { faCircleInfo, faTriangleExclamation, faExclamationCircle } from '@fortawesome/free-solid-svg-icons';
import { StyledToastContent, StyledInfoToastContainer, StyledWarningToastContainer, StyledWarningIcon, StyledInfoIcon, StyledErrorToastContainer, StyledErrorIcon } from './static-toast.styles';
import { StaticToastProps } from './static-toast.types';
const toastComponents = {
  info: {
    Container: StyledInfoToastContainer,
    Icon: StyledInfoIcon,
    icon: faCircleInfo,
    title: 'info-icon'
  },
  warning: {
    Container: StyledWarningToastContainer,
    Icon: StyledWarningIcon,
    icon: faTriangleExclamation,
    title: 'warning-icon'
  },
  error: {
    Container: StyledErrorToastContainer,
    Icon: StyledErrorIcon,
    icon: faExclamationCircle,
    title: 'error-icon'
  }
};
export const StaticToast = ({
  type,
  message
}: StaticToastProps) => {
  const toastComponent = toastComponents[type];
  if (!toastComponent) {
    return null;
  }
  const {
    Container,
    Icon,
    icon,
    title
  } = toastComponent;
  return <Container data-sentry-element="Container" data-sentry-component="StaticToast" data-sentry-source-file="static-toast.tsx">
      <Icon icon={icon} border title={title} size="2x" data-sentry-element="Icon" data-sentry-source-file="static-toast.tsx" />
      <StyledToastContent data-sentry-element="StyledToastContent" data-sentry-source-file="static-toast.tsx">{message}</StyledToastContent>
    </Container>;
};